import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {logOperationalMetric} from "../../util/CommonUtils";

const metricProcessName = "SCC_PACKAGE_SEARCH";
export async function getChildContainerHistoryForParentContainer(parentContainerLabel,
     nodeId, pageSize, pageToken = null, fromEpochMilli = null, toEpochMilli = null) {
    const requestBody = {
        "parentContainerLabel": parentContainerLabel,
        "nodeId": nodeId,
        "pageSize": pageSize,
        "pageToken": pageToken,
        "startTime": fromEpochMilli,
        "endTime": toEpochMilli
    }

    const request = {
        resourcePath: "/os/getChildContainerHistoryForParentContainer",
        httpMethod: "post",
        processName: "oculus",
        requestBody: requestBody
    }
    const startTime = Date.now();

    try {
        const response = await getAPIGatewayDataFromParent(request);
        if (response.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getChildContainerHistoryForParentContainer", true);
            return response.data;
        } else {
            logOperationalMetric(startTime, metricProcessName, "getChildContainerHistoryForParentContainer", false);
            return {
                childContainerHistory: [],
                nextPageToken: null
            }
        }
    } catch (error) {
        return {
            childContainerHistory: [],
            nextPageToken: null
        }
    }
}


// WEBPACK FOOTER //
// ./src/commons/api/GetChildContainerHistoryForParentContainerResult.js